import { Pressable } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { useRouter } from "expo-router";
import { View } from "@src/components";
import { Icon } from "@src/components/Icon";
import { sizes } from "@src/constants/sizes";
import { useRegionConfig } from "@src/hooks/useRegionConfig";
import { Breadcrumbs } from "./Breadcrumbs.web";

interface WebHeaderProps {
  onNotificationsPress?: () => void;
  hasUnread?: boolean;
}

export function WebHeader({ onNotificationsPress, hasUnread }: WebHeaderProps) {
  const { theme } = useUnistyles();
  const router = useRouter();
  const { contactUrl } = useRegionConfig();

  return (
    <View
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      height={sizes.webHeaderHeight}
      style={{
        paddingVertical: 20,
        paddingHorizontal: 28,
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.borderCard,
        zIndex: 100,
        overflow: "visible",
      }}
    >
      {/* Left side: Breadcrumbs */}
      <View flexDirection="row" alignItems="center" flex={1}>
        <Breadcrumbs />
      </View>

      {/* Right side: Settings, Help, Notifications */}
      <View flexDirection="row" alignItems="center" gap="xl">
        {onNotificationsPress && (
          <Pressable
            onPress={onNotificationsPress}
            hitSlop={8}
            accessibilityRole="button"
            accessibilityLabel="Notifications"
          >
            <Icon name="bellOutline" size={20} color={theme.colors.icon} />
            {hasUnread && (
              <View
                style={{
                  position: "absolute",
                  top: -2,
                  right: -2,
                  width: 8,
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: theme.colors.status.error,
                }}
              />
            )}
          </Pressable>
        )}

        <Pressable
          onPress={() => router.push("/settings")}
          hitSlop={8}
          accessibilityRole="button"
          accessibilityLabel="Settings"
          testID="sidebar-settings"
        >
          <Icon name="settingsOutline" size={20} color={theme.colors.icon} />
        </Pressable>

        {contactUrl && (
          <Pressable
            onPress={() => window.open(contactUrl, "_blank")}
            hitSlop={8}
            accessibilityRole="button"
            accessibilityLabel="Help"
          >
            <Icon name="help" size={20} color={theme.colors.icon} />
          </Pressable>
        )}
      </View>
    </View>
  );
}
